import { Box, Button, Stack } from "@mui/material";
import { useRef, useState } from "react";
import ReactCrop, {
  convertToPixelCrop,
  makeAspectCrop,
} from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import setCanvasPreview from "./CanvasPreview";
import { positions, useAlert } from "react-alert";
import { useDispatch } from "react-redux";
import {
  updateHeaderBase64,
  updateFooterBase64,
  updateUseDefaultLetterhead,
  updateIsHeaderCropped,
  updateIsFooterCropped,
} from "./features/reportConfig/reportConfigSlice";

const ASPECT_RATIO = 1 / 1.414;

const CropImage = ({
  imgSrc,
  crop,
  setCrop,
  cropLabel,
  setHeaderFooterBase64,
  handleCropModalClose,
}) => {
  const dispatch = useDispatch();
  const [completedCrop, setCompletedCrop] = useState({});
  const [showPreview, setShowPreview] = useState(false);
  const [headerBase64, setHeaderBase64] = useState("");
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);
  const alert = useAlert();

  const onImageLoad = (e) => {
    const { width, height, naturalWidth, naturalHeight } = e.currentTarget;
    const widthPer = (width / naturalWidth) * 100;
    const heightPer = (height / naturalHeight) * 100;
    console.log("imageDim", width, height, naturalWidth, naturalHeight);
    const crop = makeAspectCrop(
      {
        unit: "%",
        width: width,
      },
      ASPECT_RATIO,
      width,
      height
    );
    // const crop = {
    //   unit: "%",
    //   x: 0,
    //   y: 0,
    //   width: widthPer,
    //   height: heightPer,
    // };
    console.log("crorpr", crop);
    setCrop(crop);
  };

  const handleCrop = () => {
    if (!previewCanvasRef.current || !imgRef.current) {
      console.error("Canvas or Image is not initialized.");
      return;
    }

    setCanvasPreview(
      imgRef.current, // HTMLImageElement
      previewCanvasRef.current, // HTMLCanvasElement
      convertToPixelCrop(crop, imgRef.current.width, imgRef.current.height)
    );
    // const dataUrl = previewCanvasRef.current.toDataURL();

    // setHeaderBase64(dataUrl);
  };

  const saveImage = () => {
    const dataUrl = previewCanvasRef.current.toDataURL();
    if (!dataUrl) {
      alert.error(
        <span className="alertError">
          Something went wrong. Please try again
        </span>,
        {
          position: positions.TOP_CENTER,
        }
      );
      return;
    }

    if (cropLabel === "header") {
      // setHeaderFooterBase64((prevState) => ({
      //   ...prevState,
      //   headerBase64: dataUrl,
      // }));
      dispatch(updateHeaderBase64(dataUrl));
      dispatch(updateIsHeaderCropped(true));
    } else {
      // setHeaderFooterBase64((prevState) => ({
      //   ...prevState,
      //   footerBase64: dataUrl,
      // }));
      dispatch(updateFooterBase64(dataUrl));
      dispatch(updateIsFooterCropped(true));
    }
    dispatch(updateUseDefaultLetterhead(false));
    handleCropModalClose();
    alert.success(<span>Image Saved Succesfully!</span>, {
      position: positions.TOP_CENTER,
    });
  };

  console.log("completedCrop", completedCrop);

  return (
    <Box sx={{ textAlign: "center" }}>
      <ReactCrop
        crop={crop}
        keepSelection
        // disabled={headerBase64}
        onChange={(pixelCrop, percentCrop) => setCrop(percentCrop)}
        onComplete={(c) => setCompletedCrop(c)}
        minHeight={50}

        // aspect={ASPECT_RATIO}
      >
        <img
          src={imgSrc}
          alt="letterhead"
          onLoad={onImageLoad}
          width="500px"
          ref={imgRef}
        />
      </ReactCrop>
      <Box>
        <Box mt={1}>
          {completedCrop.hasOwnProperty("width") && (
            <canvas
              ref={previewCanvasRef}
              style={{
                border: "1px solid black",
                objectFit: "contain",
                width: completedCrop?.width || 500,
                height: completedCrop?.height || 100,
              }}
            />
          )}
        </Box>
        <Stack direction="row" gap={2} mt={1} justifyContent="center">
          <Button onClick={handleCrop}>Crop Image</Button>
          <Button onClick={saveImage}>Save Image</Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default CropImage;
